<template>
  <div
    v-shortkey="{ test: ['ctrl', 's'], test: ['meta', 's'] }"
    @shortkey="submitConfirmAccessibility"
  >
    <div :class="{'flexSpaceBetween' : notMobile}">
      <template v-if="!reverse">
        <div class="flexSpaceBetween width100">
          <template v-if="showPagination">
            <question-pagination :testObj="testObj"></question-pagination>
          </template>

          <div v-show="!this.isPreview">
            <button
              v-if="!isTestCompleted"
              id="test-submission-btn"
              class="test-submission btn btn-success"
              :class="{ disabled: isSubmitTestButtonDisabled }"
              @click.prevent="submitTest"
              :aria-label="
                !isSubmitTestButtonDisabled ? 'Submit Test' : 'Submit Test Disabled'
              "
              :disabled="isSubmitTestButtonDisabled"
            >
              <i class="fas fa-check marginRight8" aria-hidden="true"></i>Submit Test
            </button>
          </div>
        </div>
      </template>

      <template v-else>
        <div v-show="!this.isPreview">
          <button
            v-if="!isTestCompleted"
            class="test-submission btn btn-success"
            :class="{ disabled: isSubmitTestButtonDisabled }"
            @click.prevent="submitTest"
            :aria-label="
              !isSubmitTestButtonDisabled ? 'Submit Test' : 'Submit Test Disabled'
            "
            :disabled="isSubmitTestButtonDisabled"
          >
            <i class="fas fa-check marginRight8" aria-hidden="true"></i>Submit Test
          </button>
        </div>
        
        <template v-if="showPagination">
          <question-pagination :class="{'marginTop20' : !notMobile}" :testObj="testObj"></question-pagination>
        </template>
      </template>
      
    </div>
  </div>
</template>
<script>
import { testMixins } from "./../../../../../mixins/test";
export default {
  mixins: [testMixins],
  props: ["options",],
  components: {
    "question-pagination": require(`./question-pagination.vue`).default,
  },
  data() {
    return {
      reverse: false,
      showPagination: true,
    };
  },
  created() {
    this.reverse = _.get(this.options, "reverse", false);
    this.showPagination = _.get(this.options, "showPagination", this.showPagination);
  },
  methods: {
    submitConfirmAccessibility(event) {
      var that = this;
      event.preventDefault();
      var test_submit_modal_buttons = $(
        "#test_confirm_modal .buttonGroup button"
      );
      switch (event.srcKey) {
        case "test":
          if (!that.isSubmitTestButtonDisabled && !that.isTestCompleted) {
            that.submitTest();
          }
          break;
      }
    },
    submitTest() {
      Events.fire("submit-test");
    },
  },
  computed: {
    isSubmitTestButtonDisabled() {
      return (
        this.total_questions != this.answered_count ||
        (this.testObj.type == "trat" && !this.isTeamLeader) ||
        (this.testObj.type == "application" &&
          this.testObj.others.applicationType == "team" &&
          !this.isTeamLeader)
      );
    },
    notMobile() {
      if (window.innerWidth >= 992) {
        return true;
      }

      return false;
    },
  },
};
</script>
